import { Locale } from '../../i18n/types';
import { BrandHighlight } from '../BrandHighlight';

interface Props {
  about: Locale['about'];
  support: Locale['support'];
}

export default function AboutTab({ about, support }: Props) {
  return (
    <div>
      <div className="mb-4">
        <h2 className="tab-page-title">
          {about.heading}
        </h2>
        <p className="text-body-default">
          <BrandHighlight text={about.desc} />
        </p>
      </div>
      <div className="d-flex flex-column gap-4">
        {support.sections.map((s) => (
          <div key={s.title}>
            <div className="section-title mb-1">
              {s.title}
            </div>
            <p className="text-body">
              <BrandHighlight text={s.desc} />
            </p>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-3 divider-subtle">
        <div className="mb-2 label-uppercase-small">
          {support.linksLabel}
        </div>
        <div className="d-flex flex-column align-items-start gap-3">
          <a
            href="https://buymeacoffee.com/broomwagon"
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              border: '1px solid rgba(255, 129, 63, 0.5)',
              color: '#FF813F',
              padding: '6px 16px',
              borderRadius: '4px',
              fontSize: '0.9rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'all 0.2s',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#FF813F';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#FF813F';
            }}
          >
            <i className="bi bi-cup-hot"></i> Buy Me a Coffee
          </a>
          <div className="d-flex flex-wrap gap-4 mt-1">
            <a
              href="mailto:contact@broomwagon.app?subject=Feedback:%20Broom%20Wagon"
              style={{ color: '#c4cdd5', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.2s' }}
              onMouseOver={(e) => (e.currentTarget.style.color = '#fff')}
              onMouseOut={(e) => (e.currentTarget.style.color = '#c4cdd5')}
            >
              <i className="bi bi-chat-right-text me-2"></i> {support.actions[2].label}
            </a>
            <a
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(support.shareTweet)}&url=${encodeURIComponent('https://broomwagon.app')}`}
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#c4cdd5',
                textDecoration: 'none',
                fontSize: '0.9rem',
                transition: 'color 0.2s',
                display: 'flex',
                alignItems: 'center',
              }}
              onMouseOver={(e) => (e.currentTarget.style.color = '#fff')}
              onMouseOut={(e) => (e.currentTarget.style.color = '#c4cdd5')}
            >
              <i className="bi bi-twitter-x me-2" style={{ fontSize: '0.9rem' }}></i> {support.actions[1].label}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
